import axiosInstance from "./axios.config";

export default async function getLeagues() {
  const response = await axiosInstance.get(`/leagues`);
  return response.data;
}
